import React, { ReactElement } from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { InputTextarea, InputTextareaProps } from "primereact/inputtextarea";

interface InputTxtAreaProps extends InputTextareaProps {
  label: string;
  name: string;
  value: any;
  warn: string;
  isRequired?: boolean;
  extendedLabel?: string | ReactElement;
}
export default function InputTextareaComponent(props: InputTxtAreaProps) {
  const { name, label, warn, extendedLabel, ...rest } = props;
  const { setFieldTouched, setFieldValue } = useFormikContext();

  return (
    <div className="flex flex-column w-full py-2 txt-area-height" id={name.split(".").pop()}>
      {label && !props?.hidden && (
        <label htmlFor={name} className={rest.isRequired ? "isRequired" : ""} id={name.split(".").pop()}>
          {" "}
          {label}
        </label>
      )}
      {extendedLabel && (
        <p className="helpertext">
          <i>{extendedLabel}</i>
        </p>
      )}
      <div>
        {" "}
        <Field
          alt={name}
          name={name}
          rows={5}
          col={30}
          autoResize
          {...rest}
          as={InputTextarea}
          onChange={(e: any) => {
            setFieldTouched(name, true, true);
            setFieldValue(name, e.target.value);
          }}
        />
        {rest.value != undefined && <div className="printable-textarea-content">{rest.value}</div>}
      </div>
      {warn && <div className=" text-left fieldadv">{warn}</div>}
      <ErrorMessage name={name ?? ""} render={(msg) => <div className="error">{msg}</div>} />
    </div>
  );
}
